// @ts-nocheck
import CustomerZoneInvoiceDetail from '@/PageComponents/CustomerZone/CustomerZoneInvoice/CustomerZoneInvoiceDetail';
import { createFileRoute } from '@tanstack/react-router';

export default CustomerZoneInvoiceDetail;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/viewinvoice')({ component: CustomerZoneInvoiceDetail });
